// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2efo_","label":"styles_label__161eg"};